import React, { FC, memo } from 'react';

import { DATA_TEST_IDS } from '../../consts';
import { TEXTS } from '../../texts';
import type { AddressSelectionActionsProps } from './types';

import styles from '../index.module.scss';

const AddressSelectionActions: FC<AddressSelectionActionsProps> = ({
  hasSelectedAddresses,
  hasUnselectedAddresses,
  selectedCount,
  onReset,
  onSelectAll,
}) => (
  <div
    className={styles.dropdownHeader}
    data-testid={DATA_TEST_IDS.AUDIO_REPORT_ADDRESSES_HEADER}>
    <span
      className={styles.selectedCount}
      data-testid={DATA_TEST_IDS.AUDIO_REPORT_ADDRESSES_SELECTED_COUNT}>
      {TEXTS.AUDIO_REPORT_ADDRESSES_SELECTED_COUNT(selectedCount)}
    </span>

    {(hasUnselectedAddresses || hasSelectedAddresses) && (
      <div
        className={styles.actions}
        data-testid={DATA_TEST_IDS.AUDIO_REPORT_ADDRESSES_ACTIONS}>
        {hasUnselectedAddresses && (
          <button
            type="button"
            className={styles.actionButton}
            data-testid={DATA_TEST_IDS.AUDIO_REPORT_ADDRESSES_SELECT_ALL_BUTTON}
            onClick={onSelectAll}>
            {TEXTS.AUDIO_REPORT_ADDRESSES_SELECT_ALL}
          </button>
        )}
        {hasUnselectedAddresses && hasSelectedAddresses && <span className={styles.actionsDivider}>•</span>}
        {hasSelectedAddresses && (
          <button
            type="button"
            className={styles.actionButton}
            data-testid={DATA_TEST_IDS.AUDIO_REPORT_ADDRESSES_RESET_BUTTON}
            onClick={onReset}>
            {TEXTS.AUDIO_REPORT_ADDRESSES_RESET}
          </button>
        )}
      </div>
    )}
  </div>
);

export default memo(AddressSelectionActions);
